<!-- 基础数据--区域建筑名/料工清单/厂商信息管理--批量上传 -->
<nz-modal [(nzVisible)]="isVisible" (nzOnCancel)="isVisibleChange.emit(false)" [nzContent]="modalContent" [nzFooter]=null [nzTitle]="'BaseData.BulkUpload' | translate">
  <ng-template #modalContent>
    <nz-upload nzType="drag" [nzMultiple]="false" [nzBeforeUpload]="beforeUpload" [(nzFileList)]="fileList">
      <button nz-button><em nz-icon nzType="upload"></em>Select File</button>
      <p class="ant-upload-drag-icon">
        <em nz-icon nzType="inbox"></em>
      </p>
      <p class="ant-upload-text">{{ 'Common.UploadNote' | translate }}</p>
    </nz-upload>
     <div style="margin-top: 16px;text-align: center;">
      <button nz-button [nzType]="'primary'" [nzLoading]="uploading" (click)="handleUpload()"
        [disabled]="fileList.length == 0">
        {{ uploading ? 'Common.Uploading' : 'Common.StartUploading' | translate }}
      </button>
    </div>
  </ng-template>
 
</nz-modal>
